import { createFileRoute } from '@tanstack/react-router';
import { PublicEventPage } from '../../features/community';

export const Route = createFileRoute('/_public/events/$slug')({
  component: function PublicEventRoute() {
    const { slug } = Route.useParams();
    return <PublicEventPage slug={slug} />;
  },
});
